export const AdminRole = {
    master:"master",
    admin:"admin",
    normal:"normal",
    creator:"creator",
};
